This is the current vision category {{categoryTitle}} and its description: {{categoryDescription}}.
Here are the owners visions statements: {{visionStatements}}
This is the current integrated vision statement: {{integratedVision}}
Suggest improvements to make the integrated vision statement clearer, more compelling, explaining why the current statement is not sufficient.
